export default {
    wizardType: "SERVICENOW",

    getConnectionParams: (type, model) => ({
        ConnectionUrl: model.get("connectionUrl"),
        UserName: model.get("username"),
        Password: model.get("password"),
        ClientID: model.get("clientId"),
        ClientSecret: model.get("clientSecret"),
        useConnectionProfile: model.get("useConnectionProfile"),
        connectionProfileName: model.get("connectionProfileName"),
    }),
};

